export const getPromoList = (payload: { page: number, perPage: number }) => ({
  type: "@saga/GET_PROMO_LIST",
  payload
});
